import { confirmTaxIdFieldConfig, taxIdFieldConfig } from "./_common";

export const greatBritainFields = {
  gbNino: taxIdFieldConfig("GB", "gbNino"),
  gbConfirmNino: confirmTaxIdFieldConfig("GB", "gbNino"),
};
